import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, Modal } from '@gsa/afp-component-library';
import useReopenPeriod from './reopen-period-apis';

const DeleteReopenPeriodModal = ({
  onComplete,
  onClose,
  currentPeriodData: solPeriod = {},
}) => {
  const { deleteSolicitationPeriod } = useReopenPeriod(onComplete);

  const deleteSolPeriodMsg = `Are you sure you want to delete the ${
    solPeriod?.periodType === 'M' ? 'Mid-cycle' : 'Reopen'
  } period starting from 
  ${moment(solPeriod?.startDate).format('L')} to ${moment(
    solPeriod?.endDate,
  ).format('L')}?`;

  return (
    <Modal
      title={
        <h3 className="margin-top-5" aria-label="Delete confirmation">
          Delete confirmation
        </h3>
      }
      variant="extra-large"
      className="solicitation-modal"
      onClose={onClose}
      actions={
        solPeriod && (
          <>
            <Button
              variant="unstyled"
              className="margin-right-2"
              aria-label="Cancel"
              onClick={onClose}
              data-testid="reopen-period-delete-cancel-btn"
              label="Cancel"
            />
            <Button
              variant="secondary"
              data-testid="reopen-period-delete-remove-btn"
              aria-label="Delete"
              onClick={() => {
                deleteSolicitationPeriod({
                  variables: {
                    id: Number.parseInt(solPeriod?.id, 10),
                  },
                });
                onClose();
              }}
              label="Delete"
            />
          </>
        )
      }
      show
      onClick={onClose}
    >
      <div aria-label={deleteSolPeriodMsg}>
        Are you sure you want to delete the{' '}
        {solPeriod?.periodType === 'M' ? 'Mid-cycle' : 'Reopen'} period starting
        from <strong>{moment(solPeriod?.startDate).format('L')}</strong> to{' '}
        <strong>{moment(solPeriod?.endDate).format('L')}? </strong>
      </div>
    </Modal>
  );
};

DeleteReopenPeriodModal.propTypes = {
  onComplete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  currentPeriodData: PropTypes.shape(Object),
};

export default DeleteReopenPeriodModal;
